import {
  Button,
  Input,
  Modal,
  Popconfirm,
  Select,
  Space,
  Switch,
  Table,
} from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import * as XLSX from "xlsx";
import { selectLoading } from "../../../redux/auth/selectors";
import Client from "../../../service/Client";

export const exportToExcel = (data) => {
  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(data);

  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");

  XLSX.writeFile(workbook, "data.xlsx");
};

const ClientGroup = () => {
  const fields = [
    { name: "name", placeholder: "Name" },
    { name: "clientWebsite", placeholder: "Website" },
    { name: "complianceNote", placeholder: "Compliance Note" },
    { name: "country", placeholder: "Country" },
    { name: "ongoingScreening", placeholder: "Ongoing Screening" },
  ];
  const [Clients, setClients] = useState([]);
  const loading = useSelector(selectLoading);
  const { groupId } = useParams();

  const loadClients = useCallback(async () => {
    if (!groupId) return;

    const response = await Client.getClientsByUser(groupId);
    setClients(
      response.data
        .filter((t) => t.group === groupId)
        .map((t) => ({ ...t, key: t?._id }))
    );
  }, [groupId]);

  useEffect(() => {
    loadClients();
  }, [loadClients]);
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Business",
      dataIndex: "isBusiness",
      key: "isBusiness",
      render: (isTrue) => {
        console.log(isTrue);
        return <Space>{isTrue ? "Yes" : "No"}</Space>;
      },
    },
    {
      title: "Country",
      dataIndex: "country",
      key: "country",
    },
    {
      title: "Website",
      dataIndex: "clientWebsite",
      key: "clientWebsite",
    },
    {
      title: "Compliance Note",
      dataIndex: "complianceNote",
      key: "complianceNote",
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Space>
          <Link to={`/app/clients/related-parties/${text._id}`}>
            <Button type="primary">Details</Button>
          </Link>
          <Popconfirm
            title="Are you sure?"
            okText="Yes"
            onConfirm={() => handleDelete(text)}
          >
            <Button danger>Delete</Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];
  const [open, setOpen] = useState(false);
  const params = useParams();
  const [EditData, setEditData] = useState({
    clientId: "",
    name: "",
    isBusiness: false,
    clientWebsite: "",
    complianceNote: "",
    status: "",
    group: params.groupId,
    relatedParties: [],
    ongoingScreening: false,
  });
  const [AddData, setAddData] = useState({
    group: params.groupId,
    name: "",
    isBusiness: false,
    clientWebsite: "",
    complianceNote: "",
    status: "",
    relatedParties: [],
    ongoingScreening: false,
  });

  const handleDelete = async (data) => {
    await Client.deleteClient({
      clientId: data._id,
    }).then(() => setClients((prev) => prev.filter((t) => t._id !== data._id)));
  };
  const Edit = async () => {
    await Client.editClient({
      ...EditData,
      relatedParties: undefined,
    });
    setOpen(false);

    loadClients();
  };
  const Add = async () => {
    await Client.createClient({ ...AddData });
    setOpenAdd(false);

    loadClients();
    setAddData({
      group: params.groupId,
      name: "",
      isBusiness: false,
      clientWebsite: "",
      complianceNote: "",
      status: "",
      relatedParties: [],
      ongoingScreening: false,
    });
  };

  const handleChangeAdd = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    setAddData((prev) => ({ ...prev, [name]: value }));
  };
  const [openAdd, setOpenAdd] = useState(false);
  return (
    <div className="flex flex-col ">
      <h3>Clients</h3>
      <Table
        className="w-full max-w-2xl"
        dataSource={Clients}
        columns={columns}
        loading={loading}
        footer={() => (
          <Space>
            <Button type="primary" onClick={() => setOpenAdd(true)}>
              Add Client
            </Button>
          </Space>
        )}
      />

      <Modal
        open={openAdd}
        onCancel={() => setOpenAdd(false)}
        title="Add Client "
        onOk={Add}
        loading={loading}
        footer={[
          <Button onClick={() => setOpenAdd(false)} danger>
            Cancel
          </Button>,
          <Button type="primary" onClick={Add} loading={loading}>
            Add Client
          </Button>,
        ]}
      >
        {fields.map((e, i) => (
          <div className="mb-4" key={i}>
            <label>{e.placeholder}</label>
            {typeof AddData[e.name] === "boolean" ? (
              <Switch
                onChange={handleChangeAdd}
                name={`${e.name}`}
                placeholder={e.placeholder}
              />
            ) : (
              <Input
                value={AddData[e.name] || ""}
                onPressEnter={Add}
                onChange={handleChangeAdd}
                name={`${e.name}`}
                placeholder={e.placeholder}
                required
              />
            )}
          </div>
        ))}
        <div className="mb-4 flex w-full">
          <Select
            onPressEnter={Add}
            value={AddData.isBusiness ? "yes" : "no"}
            defaultValue={""}
            className="w-full"
            onChange={(e) => {
              e === "yes"
                ? setAddData((prev) => ({ ...prev, isBusiness: true }))
                : setAddData((prev) => ({ ...prev, isBusiness: false }));
            }}
            name={"isBusiness"}
            placeholder={"Is Business?"}
            options={[
              { label: "Yes", value: "yes" },
              { label: "No", value: "no" },
            ]}
          />
        </div>
      </Modal>
      <Modal
        open={open}
        onCancel={() => setOpen(false)}
        title="Edit Client "
        onOk={Edit}
        loading={loading}
        footer={[
          <Button onClick={() => setOpen(false)} danger>
            Cancel
          </Button>,
          <Button type="primary" onClick={Edit} loading={loading}>
            Edit Client
          </Button>,
        ]}
      >
        {fields.map((e, i) => (
          <div className="mb-4" key={i}>
            <label>{e.placeholder}</label>
            {typeof EditData[e.name] === "boolean" ? (
              <Switch
                onChange={handleChangeAdd}
                name={`${e.name}`}
                placeholder={e.placeholder}
              />
            ) : (
              <Input
                value={EditData[e.name] || ""}
                onPressEnter={Add}
                onChange={handleChangeAdd}
                name={`${e.name}`}
                placeholder={e.placeholder}
                required
              />
            )}
          </div>
        ))}
        <div className="mb-4 flex w-full">
          <Select
            onPressEnter={Edit}
            value={EditData.isBusiness ? "yes" : "no"}
            defaultValue={""}
            className="w-full"
            onChange={(e) => {
              e === "yes"
                ? setEditData((prev) => ({ ...prev, isBusiness: true }))
                : setEditData((prev) => ({ ...prev, isBusiness: false }));
            }}
            name={"isBusiness"}
            placeholder={"Is Business?"}
            options={[
              { label: "Yes", value: "yes" },
              { label: "No", value: "no" },
            ]}
          />
        </div>
      </Modal>
    </div>
  );
};

export default ClientGroup;
